import { useState, useEffect, useContext } from "react";
import AuthContext from "../../Context/AuthContext";
import { Link, useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList, faPlus, faRecycle } from "@fortawesome/free-solid-svg-icons";
import Dropdown from "react-bootstrap/Dropdown";
import IndicatorsList from "../Components/IndicatorsList";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import "./PersonIndicators.css";

function PersonIndicators() {
  const [isLoading, setIsLoading] = useState(true);
  const [openIndicators, setOpenIndicators] = useState([]);
  const [closedIndicators, setClosedIndicators] = useState([]);
  const [user, setUser] = useState({});

  const { state } = useContext(AuthContext);

  let { pid } = useParams();

  const { t } = useTranslation();

  useEffect(() => {
    async function fetch() {
      const response = await axios({
        method: "get",
        url: `${process.env.REACT_APP_BACKEND_URL}/indicators/organization/${pid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setOpenIndicators(response.data.openIndicators);
      setClosedIndicators(response.data.closedIndicators);
      setUser(response.data.user);
      setIsLoading(false);
    }
    fetch();
  }, [state.organization, state.token, pid]);

  const updateIndicatorsApprover = async () => {
    try {
      setIsLoading(true);
      const response = await axios({
        method: "put",
        url: `${process.env.REACT_APP_BACKEND_URL}/indicators/approver/${pid}`,
        headers: {
          Authorization: `Bearer ${state.token}`,
        },
      });
      setIsLoading(false);
      toast(response.data.message);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      toast.error(error.response.data.message);
    }
  };

  if (isLoading === true) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  } else {
    return (
      <Container fluid>
        <ToastContainer />
        <Row className="align-items-center">
          <Col lg={11} className="person-indicators-header">
            <h2>
              {t("Indicadores.MisIndicadores.Titulo")} - {user.firstName}{" "}
              {user.lastName}
            </h2>
          </Col>
          <Col lg={1} className="right person-indicators-content">
            <Dropdown>
              <Dropdown.Toggle id="dropdown-basic">
                <FontAwesomeIcon icon={faList} />
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item as={Link} to={`/indicators/new`}>
                  <FontAwesomeIcon icon={faPlus} />{" "}
                  {t("Indicadores.MisIndicadores.NuevoIndicador")}
                </Dropdown.Item>
                <Dropdown.Item onClick={() => updateIndicatorsApprover()}>
                  <FontAwesomeIcon icon={faRecycle} />{" "}
                  {t("Indicadores.MisIndicadores.ActualizarJefe")}
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Col>
        </Row>
        <Row className="align-items-center">
          {openIndicators.length === 0 ? (
            <Col className="empty-indicators center">
              <h5>{t("Indicadores.MisIndicadores.SinIndicadores")}</h5>
            </Col>
          ) : (
            <IndicatorsList
              indicators={openIndicators}
              language={state.language}
            />
          )}
        </Row>
      </Container>
    );
  }
}

export default PersonIndicators;
